import request from '@/service/lib/request'

/**
 * 小麦流行病 - 设备列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getDevices(companyId) {
  return request({
    url: `/api/v2/epid/devices`,
    method: 'get',
    params: { companyId }
  })
}

/**
 * 小麦流行病 - 设备信息 包含当前气象数据
 * @param {String} url 请求地址
 * @param {String} companyId 组织 ID
 * @param {String} id 设备 ID
 */
export function info(companyId, id) {
  return request({
    url: `/api/v2/epid/devices/${id}/info`,
    method: 'get',
    params: { companyId }
  })
}

/**
 * 小麦流行病 - 气象历史数据
 * @param {String} url 请求地址
 * @param {String} companyId 组织 ID
 * @param {String} id 设备 ID
 */
export function weather(companyId, id, startDate, endDate) {
  return request({
    url: `/api/v2/epid/devices/${id}/weather`,
    method: 'get',
    params: { companyId, startDate, endDate }
  })
}

/**
 * 小麦流行病 - 预测结果
 * @param {String} url 请求地址
 * @param {String} deviceId 设备 ID
 * @param {String} data.id 主键 ID 参考文档
 * @param {String} data.startDate 扬花期开始时间
 * @param {String} data.endDate 扬花期结束时间
 */
export function getPredict(id, companyId, type) {
  return request({
    url: `/api/v2/epid/devices/${id}/predict`,
    method: 'get',
    params: { type, companyId }
  })
}

/**
 * 小麦流行病 - 赤霉病预测更新
 * @param {String} url 请求地址
 * @param {String} deviceId 设备 ID
 * @param {String} data.id 主键 ID 参考文档
 * @param {String} data.startDate 扬花期开始时间
 * @param {String} data.endDate 扬花期结束时间
 */
export function setGibble(deviceId, data) {
  return request({
    url: `/api/v2/epid/devices/${deviceId}/gibble`,
    method: 'put',
    data
  })
}

/**
 * 小麦流行病 - 预测结果
 * @param {String} url 请求地址
 * @param {String} deviceId 设备 ID
 * @param {String} data.id 主键 ID 参考文档
 * @param {String} data.headingTime 抽穗期时间
 */
export function setPowdery(deviceId, data) {
  return request({
    url: `/api/v2/epid/devices/${deviceId}/powdery`,
    method: 'put',
    data
  })
}
